import { BigButton } from "./BigButton";

export default function PagingControl({ totalPages, pageNum, setPageNum }) {
  const styles = {
    container: {
      marginTop: 8,
      marginBottom: 8,
    },
    inlineFlex: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    pageInfo: {
      padding: 7,
      color: '#000',
      fontSize: 14,
      borderTop: "1px solid #21293629",
      borderBottom: "1px solid #21293629",
    }
  }
  return (
    <div style={styles.container}>
      <div style={styles.inlineFlex}>
        <BigButton
          title={"<<"}
          onClick={() => setPageNum(0)}
          disabled={pageNum === 0}
          style={{ borderColor: '#21293629', borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
        />
        <BigButton
          title={"<"}
          onClick={() => setPageNum(pageNum - 1)}
          disabled={pageNum - 1 === -1}
          style={{ borderColor: '#21293629', borderRadius: 0, borderLeft: 'none' }}
        />
        <div style={styles.pageInfo}>
          Page: {pageNum + 1}/{totalPages}
        </div>
        <BigButton
          title={">"}
          onClick={() => setPageNum(pageNum + 1)}
          disabled={pageNum + 1 > totalPages - 1}
          style={{ borderColor: '#21293629', borderRadius: 0, borderRight: 'none' }}
        />
        <BigButton
          title={">>"}
          onClick={() => setPageNum(totalPages - 1)}
          disabled={pageNum === totalPages - 1}
          style={{ borderColor: '#21293629', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        />
      </div>
    </div>
  );
}
